import { useEffect, useState } from 'react';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';

function handleModeQueryParam(
  modeQueryParam: string | null
): 'full' | 'compact' {
  if (modeQueryParam !== 'full' && modeQueryParam !== 'compact') {
    return 'compact';
  }

  if (modeQueryParam === null) {
    return 'compact';
  }

  return modeQueryParam;
}

const useNoteModalMode = () => {
  const { getItem, setItem } = useQueryStringParam();
  const modeQueryParam = getItem('mode');
  const mode = handleModeQueryParam(modeQueryParam);
  const [currentMode, setCurrentMode] = useState<'full' | 'compact'>(mode);
  useEffect(() => {
    if (currentMode !== mode && modeQueryParam !== null) {
      setItem('mode', currentMode);
    }
  }, [currentMode]);

  return { modalMode: currentMode, setModalMode: setCurrentMode };
};

export default useNoteModalMode;
